export default function AddonsIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_80136_100582'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_80136_100582)'>
        <path
          d='M2.5 19.5023H8.90375V13.0985H2.5V19.5023ZM4 9.40625V6.00225H10.404V9.40625H4ZM2.5 10.906H11.9038V4.50225H2.5V10.906ZM12.596 18.0023V14.5983H20V18.0023H12.596ZM11.0963 19.5023H21.5V13.0985H11.0963V19.5023ZM4 18.0023V14.5983H7.404V18.0023H4ZM18 10.906C16.7513 10.906 15.6892 10.4683 14.8135 9.59275C13.9378 8.71708 13.5 7.65492 13.5 6.40625C13.5 5.15742 13.9378 4.09517 14.8135 3.2195C15.6892 2.344 16.7513 1.90625 18 1.90625C19.2487 1.90625 20.3108 2.344 21.1865 3.2195C22.0622 4.09517 22.5 5.15742 22.5 6.40625C22.5 7.65492 22.0622 8.71708 21.1865 9.59275C20.3108 10.4683 19.2487 10.906 18 10.906ZM17.5577 9.3485H18.4423V6.8485H20.9423V5.96375H18.4423V3.46375H17.5577V5.96375H15.0577V6.8485H17.5577V9.3485Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
